/* Ela Wonen — "Meer producten laden" (Load More) for collection & search grids.
 *
 * Progressive enhancement over a normal next-page link: on click it fetches
 * the next page's section HTML (via Shopify's ?section_id= rendering),
 * appends the new product cards to the current grid, then updates the
 * button's target to the following page — or removes it on the last page.
 *
 * If JS is unavailable the button is a real <a href> to the next page, so
 * it still works as plain navigation.
 *
 * Uses event delegation on document so it keeps working after the section
 * is re-rendered (e.g. when filters/sorting update the grid).
 */
(function () {
  var BUSY = 'aria-busy';

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-ela-load-more-btn]') : null;
    if (!btn) return;

    event.preventDefault();
    if (btn.getAttribute(BUSY) === 'true') return;

    var nextUrl = btn.getAttribute('href');
    var sectionId = btn.getAttribute('data-section-id');
    if (!nextUrl || !sectionId) return;

    var section = btn.closest('.shopify-section') || document;
    var grid = section.querySelector('ul[ref="grid"]') || document.querySelector('ul[ref="grid"]');
    if (!grid) return;

    var label = btn.textContent;
    btn.setAttribute(BUSY, 'true');
    btn.textContent = btn.getAttribute('data-loading-text') || label;

    var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newItems = doc.querySelectorAll('ul[ref="grid"] > [ref="cards[]"]');
        for (var i = 0; i < newItems.length; i++) {
          grid.appendChild(document.importNode(newItems[i], true));
        }

        var newBtn = doc.querySelector('[data-ela-load-more-btn]');
        if (newBtn && newBtn.getAttribute('href')) {
          btn.setAttribute('href', newBtn.getAttribute('href'));
          btn.textContent = label;
          btn.removeAttribute(BUSY);
        } else {
          var wrapper = btn.closest('[data-ela-load-more]');
          (wrapper || btn).remove();
        }

        try {
          history.replaceState({}, '', nextUrl);
        } catch (err) {
          /* history not available — ignore */
        }
      })
      .catch(function () {
        btn.textContent = label;
        btn.removeAttribute(BUSY);
      });
  });
})();
